import React from "react";

/**
 * SoundsIcon
 *
 * @param {object} props - props object.
 * @param {object} props.className - styled components class name.
 * @returns {JSX.Element} SoundsIcon
 */
function SoundsIcon({ className, styles }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={styles}
    >
      <g clipPath="url(#clip0_8712_21481)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.59438 7.60385V14.6374C7.59438 15.0917 7.45965 15.5359 7.20724 15.9136C6.95482 16.2914 6.59605 16.5858 6.17629 16.7597C5.75653 16.9336 5.29464 16.9791 4.84903 16.8904C4.40342 16.8018 3.9941 16.583 3.67283 16.2617C3.35156 15.9405 3.13278 15.5311 3.04414 15.0855C2.9555 14.6399 3.001 14.178 3.17486 13.7583C3.34873 13.3385 3.64317 12.9798 4.02094 12.7273C4.39871 12.4749 4.84285 12.3402 5.29719 12.3402C5.70206 12.3428 6.09876 12.4543 6.44579 12.6628V4.87109C6.44604 4.74684 6.48682 4.62606 6.56193 4.52707C6.63705 4.42809 6.74239 4.3563 6.86199 4.32261L14.9828 2.02219C15.0683 1.99772 15.1582 1.99342 15.2456 2.00963C15.333 2.02584 15.4155 2.06211 15.4865 2.11559C15.5575 2.16907 15.6151 2.2383 15.6548 2.31783C15.6945 2.39736 15.7151 2.48502 15.7152 2.5739V7.45543L14.5634 7.77807V5.63252L7.59438 7.60385ZM20.1095 17.4056V7.63932C20.1095 7.55002 20.0887 7.46196 20.0488 7.38205C20.009 7.30215 19.9511 7.23257 19.8798 7.17879C19.8085 7.12502 19.7258 7.0885 19.638 7.07212C19.5502 7.05574 19.4598 7.05993 19.3739 7.08438L11.2563 9.38479C11.1359 9.41853 11.0297 9.49067 10.954 9.59025C10.8783 9.68983 10.8372 9.81141 10.8369 9.93651V17.7282C10.4908 17.5202 10.0953 17.4088 9.69153 17.4056C9.23705 17.405 8.7926 17.5391 8.4144 17.7912C8.03621 18.0432 7.74127 18.4018 7.5669 18.8215C7.39254 19.2412 7.34659 19.7031 7.43486 20.149C7.52313 20.5948 7.74167 21.0044 8.06281 21.326C8.38394 21.6476 8.79326 21.8667 9.23896 21.9556C9.68466 22.0445 10.1467 21.9992 10.5667 21.8254C10.9866 21.6517 11.3456 21.3572 11.5981 20.9794C11.8507 20.6015 11.9855 20.1573 11.9855 19.7028V12.6693L18.9577 10.7108V15.4311C18.6107 15.2225 18.214 15.1111 17.8091 15.1084C17.354 15.1084 16.9091 15.2434 16.5308 15.4963C16.1524 15.7492 15.8575 16.1087 15.6835 16.5292C15.5095 16.9498 15.4641 17.4125 15.5532 17.8588C15.6422 18.3051 15.8616 18.715 16.1836 19.0366C16.5057 19.3582 16.9159 19.577 17.3623 19.6654C17.8088 19.7538 18.2714 19.7078 18.6917 19.5332C19.112 19.3586 19.471 19.0632 19.7234 18.6845C19.9758 18.3058 20.1102 17.8607 20.1095 17.4056Z"
          fill="currentcolor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8712_21481">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SoundsIcon;
